import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import { currencyFormat } from 'src/common/utils/functions';
import { THEME } from 'src/styles/theme';
import { HandleChangeParams, AllocatedFunds } from './types';
import { mobileBreakpoint } from 'src/containers/client-assessment/mobileBreakpoint';
import Minus from 'src/assets/components/Minus';
import Plus from 'src/assets/components/Plus';

type ItemInfo = {
  label: string;
  value: string;
  image?: string;
  imageTitle?: string;
};

type Props = {
  item: ItemInfo;
  allocatedFunds: AllocatedFunds;
  remainingFunds: number;
  handleActionClick: (x: HandleChangeParams) => void;
  useAltImg?: boolean;
  hideButtons?: boolean;
};
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 20%;
  margin: 0.75em;
  h6 {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
  }
  @media ${mobileBreakpoint.mobile} {
    margin-left: 0;
  }
`;

type TopSectionProps = {
  imageUrl?: string;
};

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 10em;
  padding: 1em;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-image: linear-gradient(to bottom, rgba(29, 29, 29, 0), #000),
    url('${(props: TopSectionProps) => (props.imageUrl ? props.imageUrl : '')}');
  background-position: bottom;
  background-size: cover;
  background-repeat: no-repeat;
  h6 {
    color: #fff;
  }
`;

const BottomSection = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 0.5em 1em;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(160, 177, 186, 0.25);
  h6 {
    color: #033e3e;
    font: 500 1.0625rem/1.3125rem Inter, sans-serif;
  }
  svg {
    &:hover {
      cursor: pointer;
    }
  }
`;

const AllocationContainer = muiStyled('div')(({ theme }) => ({
  height: 36,
  margin: 0,
  padding: '2px 4px',
  borderBottomLeftRadius: 15,
  borderBottomRightRadius: 15,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const OptionBoxText = muiStyled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  color: THEME.main.primary,
  borderRadius: '5px',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '20px',
  fontWeight: 'bold',
  textAlign: 'left',
  justifyContent: 'space-between',
}));

const IconBtnRootClass = muiStyled('div')(theme => ({
  flex: '0 0 auto',
  color: 'rgba(0, 0, 0, 0.54)',
  padding: '6px 8px',
  overflow: 'visible',
  fontSize: '1.5rem',
  textAlign: 'center',
  transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  borderRadius: '50%',
}));

function Item({
  item,
  remainingFunds,
  allocatedFunds,
  hideButtons = false,
  handleActionClick,
  useAltImg = false,
}: Props) {
  return (
    <Wrapper>
      <TopSection
        imageUrl={
          item.imageTitle?.includes('https:')
            ? item.imageTitle
            : `https://static.tifingrow.com/theme_logos/${item.imageTitle}`
        }
      >
        <h6>{item.label}</h6>
      </TopSection>
      <BottomSection>
        <span
          onClick={() =>
            handleActionClick({ property: item.value, type: 'DEC' })
          }
        >
          {' '}
          <Minus />
        </span>
        <h6>{'$' + currencyFormat(allocatedFunds[item.value] ?? 0)}</h6>
        <span
          onClick={() =>
            handleActionClick({ property: item.value, type: 'INC' })
          }
        >
          <Plus />
        </span>
      </BottomSection>
    </Wrapper>
  );
}

export default Item;
